import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {UserOPEEnum} from "./UserOPEEnum";

class O {
}

/**
 * I Inner Class
 */
class I {
  userId!: number;
  baseFeUrl!: string;
  action!: string;
}


/**
 * SendUserWelcomeEmailCB class
 */
export class SendUserWelcomeEmailCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(UserOPEEnum.SendUserWelcomeEmail);
    this.i = new I();
    this.o = new O();
  }

}
